<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('priorities.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button v-if="$can(abilities.CREATE_PRIORITY)" btn-class="btn-sm" type="new" btn-text="priorities.create" @click="openPriorityModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_priorities" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-200px">{{ $t('priorities.title')}}</th>
              <th class="min-w-100px">{{ $t('priorities.color')}}</th>
              <th class="w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <PriorityModal id="create-priority-modal" @load="fetchDatas"/>
    <PriorityModal id="edit-priority-modal" :form="formUpdateData" @load="fetchDatas" :edit="true"/>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import PriorityModal from "../../../components/Modals/PriorityModal"

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const currency = computed(() => 'XOF')
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  title: '',
  color: '#000'
})

onMounted(() => {
  fetchDatas()
})

watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#kt_datatable_priorities").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + "/task-priorities/datatables",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "title" },
      { data: "color" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -3,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + t + "</span>";
        },
      },
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<div style="width: 50%; border: 8px solid ' + e.color + '; border-radius: 5px; background-color: ' + e.color + '" data-id="'+ e.id +'"></div>';
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_PRIORITY)){
            render+='<a data-id="'+ e.id +'" data-title="'+ e.title +'" data-color="'+ e.color +'"  href="javascript:;"   class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-title="'+ e.title +'" data-color="'+ e.color +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(can(abilities.DELETE_PRIORITY)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_priorities .edit_btn", (e) => {
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.title = e.target.getAttribute('data-title')
    formUpdateData.value.color = e.target.getAttribute('data-color')
    $('#edit-priority-modal').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_priorities .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deletePriority(id)
  });
}

function openPriorityModal() {
  $('#create-priority-modal').modal('toggle')
}

async function deletePriority(id) {
    showSwal(
        '',
        i18n.global.t('priorities.priority_deleted')
    ).then( async (result) => {
        if (result.value) {
            try {
                await store.dispatch('taskPriorities/deleteTaskPriority', id)
                table.value.ajax.reload()
                window.toastr['success'](i18n.global.t("priorities.deleted_successfully"))
            }catch (e) {
            }
        }
  })
}
</script>
